function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { api } from './configs/axiosConfig';
export var UserAPI = {
    /**
     * Get all users or a specific user by username
     */
    getUsers: function () {
        var _getUsers = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(username) {
            var params, response;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            params = username ? {
                                username: username,
                                all: true
                            } : {
                                all: true
                            };
                            _context.n = 1;
                            return api.get('/user', {
                                params: params
                            });
                        case 1:
                            response = _context.v;
                            return _context.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee);
        }));
        function getUsers(_x) {
            return _getUsers.apply(this, arguments);
        }
        return getUsers;
    }(),
    /**
     * Create a new user
     */
    createUser: function () {
        var _createUser = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(userData) {
            var response;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return api.post('/user', userData);
                        case 1:
                            response = _context2.v;
                            return _context2.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee2);
        }));
        function createUser(_x2) {
            return _createUser.apply(this, arguments);
        }
        return createUser;
    }(),
    /**
     * Update an existing user
     */
    updateUser: function () {
        var _updateUser = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(id, userData) {
            var response;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            _context3.n = 1;
                            return api.put("/user", userData, {
                                params: {
                                    id: id
                                }
                            });
                        case 1:
                            response = _context3.v;
                            return _context3.a(2, response.data);
                    }
            }, _callee3);
        }));
        function updateUser(_x3, _x4) {
            return _updateUser.apply(this, arguments);
        }
        return updateUser;
    }(),
    /**
     * Update user preferences (name, phone, language, audio settings)
     * Convenience method that handles the payload construction for settings updates
     */
    updateUserPreferences: function updateUserPreferences(user, preferences) {
        var _this = this;
        return _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            var existingDetails, mergedMessagePreferences, details, userAttributes, payload;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            existingDetails = user.details || {};
                            mergedMessagePreferences = _objectSpread(_objectSpread({}, existingDetails.messagePreferences || {}), preferences.messagePreferences || {});
                            details = _objectSpread(_objectSpread({}, existingDetails), {}, {
                                selected_language: preferences.selectedLanguage,
                                audio: preferences.audio,
                                messagePreferences: mergedMessagePreferences
                            }); // Only update phone if explicitly provided in preferences
                            userAttributes = _objectSpread(_objectSpread({}, user.userAttributes), {}, {
                                name: preferences.preferredName
                            }); // Handle phone update: undefined = don't change, null = clear, object = update
                            if (preferences.phone !== undefined) {
                                userAttributes.phone = preferences.phone ? JSON.stringify(preferences.phone) : '';
                            }
                            payload = {
                                resourceType: 'User',
                                username: user.username,
                                userAttributes: userAttributes,
                                details: details,
                                metadata: user === null || user === void 0 ? void 0 : user.metadata
                            };
                            return _context4.a(2, _this.updateUser(user.id, payload));
                    }
            }, _callee4);
        }))();
    },
    /**
     * Add feedback rating to user details
     * Convenience method that appends a new rating to the ratings array in user details
     */
    addFeedbackRating: function addFeedbackRating(user, rating) {
        var _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var existingDetails, existingRatings, payload;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.n) {
                        case 0:
                            // Get existing ratings array or create new one
                            existingDetails = user.details || {};
                            existingRatings = Array.isArray(existingDetails.ratings) ? existingDetails.ratings : [];
                            payload = {
                                resourceType: 'User',
                                username: user.username,
                                userAttributes: user.userAttributes,
                                details: _objectSpread(_objectSpread({}, existingDetails), {}, {
                                    ratings: [].concat(_toConsumableArray(existingRatings), [rating])
                                }),
                                metadata: user === null || user === void 0 ? void 0 : user.metadata
                            };
                            return _context5.a(2, _this2.updateUser(user.id, payload));
                    }
            }, _callee5);
        }))();
    },
    /**
     * Delete a user by ID or username
     */
    deleteUser: function () {
        var _deleteUser = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6(id, username) {
            var params, response;
            return _regenerator().w(function (_context6) {
                while (1)
                    switch (_context6.n) {
                        case 0:
                            params = {};
                            if (id)
                                params.id = id;
                            if (username)
                                params.username = username;
                            _context6.n = 1;
                            return api["delete"]('/user', {
                                params: params
                            });
                        case 1:
                            response = _context6.v;
                            return _context6.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee6);
        }));
        function deleteUser(_x5, _x6) {
            return _deleteUser.apply(this, arguments);
        }
        return deleteUser;
    }(),
    /**
     * Assign a role to a user
     */
    assignRole: function () {
        var _assignRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7(username, roleData) {
            var response;
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.n) {
                        case 0:
                            _context7.n = 1;
                            return api.post("/user/role?username=".concat(username), roleData);
                        case 1:
                            response = _context7.v;
                            return _context7.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee7);
        }));
        function assignRole(_x7, _x8) {
            return _assignRole.apply(this, arguments);
        }
        return assignRole;
    }(),
    /**
     * Update a role assigned to a user
     */
    updateUserRole: function () {
        var _updateUserRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee8(username, roleData) {
            var response;
            return _regenerator().w(function (_context8) {
                while (1)
                    switch (_context8.n) {
                        case 0:
                            _context8.n = 1;
                            return api.put("/user/role?username=".concat(username), roleData);
                        case 1:
                            response = _context8.v;
                            return _context8.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee8);
        }));
        function updateUserRole(_x9, _x0) {
            return _updateUserRole.apply(this, arguments);
        }
        return updateUserRole;
    }(),
    /**
     * Remove a role from a user
     */
    removeRole: function () {
        var _removeRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee9(userId, roleId) {
            var response;
            return _regenerator().w(function (_context9) {
                while (1)
                    switch (_context9.n) {
                        case 0:
                            _context9.n = 1;
                            return api["delete"]("/user/role?userId=".concat(userId, "&roleId=").concat(roleId));
                        case 1:
                            response = _context9.v;
                            return _context9.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee9);
        }));
        function removeRole(_x1, _x10) {
            return _removeRole.apply(this, arguments);
        }
        return removeRole;
    }(),
    /**
     * Get all roles or roles for a specific user
     */
    getRoles: function () {
        var _getRoles = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee0(username) {
            var params, response;
            return _regenerator().w(function (_context0) {
                while (1)
                    switch (_context0.n) {
                        case 0:
                            params = username ? {
                                username: username
                            } : {
                                all: true
                            };
                            _context0.n = 1;
                            return api.get('/role', {
                                params: params
                            });
                        case 1:
                            response = _context0.v;
                            return _context0.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee0);
        }));
        function getRoles(_x11) {
            return _getRoles.apply(this, arguments);
        }
        return getRoles;
    }(),
    /**
     * Get roles specifically assigned to a user by username
     */
    getUserRoles: function () {
        var _getUserRoles = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee1(username) {
            var response;
            return _regenerator().w(function (_context1) {
                while (1)
                    switch (_context1.n) {
                        case 0:
                            _context1.n = 1;
                            return api.get('/user/role', {
                                params: {
                                    username: username
                                }
                            });
                        case 1:
                            response = _context1.v;
                            return _context1.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee1);
        }));
        function getUserRoles(_x12) {
            return _getUserRoles.apply(this, arguments);
        }
        return getUserRoles;
    }(),
    /**
     * Get all users with their roles aggregated - optimized for Team Access page
     * This method returns all users with their assigned roles in a single API call
     * to avoid multiple individual getUserRoles calls
     */
    getUsersWithRoles: function () {
        var _getUsersWithRoles = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee10() {
            var response;
            return _regenerator().w(function (_context10) {
                while (1)
                    switch (_context10.n) {
                        case 0:
                            _context10.n = 1;
                            return api.get('/user/with-roles');
                        case 1:
                            response = _context10.v;
                            return _context10.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee10);
        }));
        function getUsersWithRoles() {
            return _getUsersWithRoles.apply(this, arguments);
        }
        return getUsersWithRoles;
    }(),
    /**
     * Get all roles with their policies and assignment counts aggregated - optimized for Role Management page
     * This method returns all roles with their policies and user assignment counts in a single API call
     * to avoid multiple individual getRolePolicies and getRoleAssignmentCount calls
     */
    getRolesWithPoliciesAndCounts: function () {
        var _getRolesWithPoliciesAndCounts = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee11() {
            var response;
            return _regenerator().w(function (_context11) {
                while (1)
                    switch (_context11.n) {
                        case 0:
                            _context11.n = 1;
                            return api.get('/role/with-policies-and-counts');
                        case 1:
                            response = _context11.v;
                            return _context11.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee11);
        }));
        function getRolesWithPoliciesAndCounts() {
            return _getRolesWithPoliciesAndCounts.apply(this, arguments);
        }
        return getRolesWithPoliciesAndCounts;
    }(),
    /**
     * Create a new role
     */
    createRole: function () {
        var _createRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee12(roleData) {
            var response;
            return _regenerator().w(function (_context12) {
                while (1)
                    switch (_context12.n) {
                        case 0:
                            _context12.n = 1;
                            return api.post('/role', roleData);
                        case 1:
                            response = _context12.v;
                            return _context12.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee12);
        }));
        function createRole(_x13) {
            return _createRole.apply(this, arguments);
        }
        return createRole;
    }(),
    /**
     * Update an existing role
     */
    updateRole: function () {
        var _updateRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee13(id, roleData) {
            var response;
            return _regenerator().w(function (_context13) {
                while (1)
                    switch (_context13.n) {
                        case 0:
                            _context13.n = 1;
                            return api.put("/role/".concat(id), roleData);
                        case 1:
                            response = _context13.v;
                            return _context13.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee13);
        }));
        function updateRole(_x14, _x15) {
            return _updateRole.apply(this, arguments);
        }
        return updateRole;
    }(),
    /**
     * Delete a role
     */
    deleteRole: function () {
        var _deleteRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee14(id) {
            var response;
            return _regenerator().w(function (_context14) {
                while (1)
                    switch (_context14.n) {
                        case 0:
                            _context14.n = 1;
                            return api["delete"]("/role/".concat(id));
                        case 1:
                            response = _context14.v;
                            return _context14.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee14);
        }));
        function deleteRole(_x16) {
            return _deleteRole.apply(this, arguments);
        }
        return deleteRole;
    }(),
    /**
     * Get all policies or policies for a specific user
     */
    getPolicies: function () {
        var _getPolicies = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee15(username) {
            var params, response;
            return _regenerator().w(function (_context15) {
                while (1)
                    switch (_context15.n) {
                        case 0:
                            params = username ? {
                                username: username
                            } : {
                                all: true
                            };
                            _context15.n = 1;
                            return api.get('/policy', {
                                params: params
                            });
                        case 1:
                            response = _context15.v;
                            return _context15.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee15);
        }));
        function getPolicies(_x17) {
            return _getPolicies.apply(this, arguments);
        }
        return getPolicies;
    }(),
    /**
     * Create a new policy
     */
    createPolicy: function () {
        var _createPolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee16(policyData) {
            var response;
            return _regenerator().w(function (_context16) {
                while (1)
                    switch (_context16.n) {
                        case 0:
                            _context16.n = 1;
                            return api.post('/policy', policyData);
                        case 1:
                            response = _context16.v;
                            return _context16.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee16);
        }));
        function createPolicy(_x18) {
            return _createPolicy.apply(this, arguments);
        }
        return createPolicy;
    }(),
    /**
     * Update an existing policy
     */
    updatePolicy: function () {
        var _updatePolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee17(id, policyData) {
            var response;
            return _regenerator().w(function (_context17) {
                while (1)
                    switch (_context17.n) {
                        case 0:
                            _context17.n = 1;
                            return api.put("/policy/".concat(id), policyData);
                        case 1:
                            response = _context17.v;
                            return _context17.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee17);
        }));
        function updatePolicy(_x19, _x20) {
            return _updatePolicy.apply(this, arguments);
        }
        return updatePolicy;
    }(),
    /**
     * Delete a policy
     */
    deletePolicy: function () {
        var _deletePolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee18(id) {
            var response;
            return _regenerator().w(function (_context18) {
                while (1)
                    switch (_context18.n) {
                        case 0:
                            _context18.n = 1;
                            return api["delete"]("/policy/".concat(id));
                        case 1:
                            response = _context18.v;
                            return _context18.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee18);
        }));
        function deletePolicy(_x21) {
            return _deletePolicy.apply(this, arguments);
        }
        return deletePolicy;
    }(),
    /**
     * Get policies assigned to a specific role
     */
    getRolePolicies: function () {
        var _getRolePolicies = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee19(roleId) {
            var response;
            return _regenerator().w(function (_context19) {
                while (1)
                    switch (_context19.n) {
                        case 0:
                            _context19.n = 1;
                            return api.get("/rolepolicy/".concat(roleId, "/policy"));
                        case 1:
                            response = _context19.v;
                            return _context19.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee19);
        }));
        function getRolePolicies(_x22) {
            return _getRolePolicies.apply(this, arguments);
        }
        return getRolePolicies;
    }(),
    /**
     * Get rolepolicy records for a specific policy (to check which roles use it)
     */
    getPolicyRoleRecords: function () {
        var _getPolicyRoleRecords = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee20(policyId) {
            var _response$data;
            var response;
            return _regenerator().w(function (_context20) {
                while (1)
                    switch (_context20.n) {
                        case 0:
                            _context20.n = 1;
                            return api.get("/rolepolicy/policy/".concat(policyId, "/records"));
                        case 1:
                            response = _context20.v;
                            return _context20.a(2, (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.resource) || []);
                    }
            }, _callee20);
        }));
        function getPolicyRoleRecords(_x23) {
            return _getPolicyRoleRecords.apply(this, arguments);
        }
        return getPolicyRoleRecords;
    }(),
    /**
     * Delete a specific rolepolicy by its ID
     */
    deleteRolePolicyById: function () {
        var _deleteRolePolicyById = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee21(rolePolicyId) {
            return _regenerator().w(function (_context21) {
                while (1)
                    switch (_context21.n) {
                        case 0:
                            _context21.n = 1;
                            return api["delete"]("/rolepolicy/".concat(rolePolicyId));
                        case 1:
                            return _context21.a(2);
                    }
            }, _callee21);
        }));
        function deleteRolePolicyById(_x24) {
            return _deleteRolePolicyById.apply(this, arguments);
        }
        return deleteRolePolicyById;
    }(),
    /**
     * Get the number of users assigned to a role from principalrole table
     */
    getRoleAssignmentCount: function () {
        var _getRoleAssignmentCount = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee22(roleId) {
            var _response$data2;
            var response;
            return _regenerator().w(function (_context22) {
                while (1)
                    switch (_context22.n) {
                        case 0:
                            _context22.n = 1;
                            return api.get("/role/".concat(roleId, "/assignment/count"));
                        case 1:
                            response = _context22.v;
                            return _context22.a(2, (response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.count) || 0);
                    }
            }, _callee22);
        }));
        function getRoleAssignmentCount(_x25) {
            return _getRoleAssignmentCount.apply(this, arguments);
        }
        return getRoleAssignmentCount;
    }(),
    /**
     * Create role-policy associations (assign policies to a role)
     */
    createRolePolicy: function () {
        var _createRolePolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee23(requestData) {
            var response;
            return _regenerator().w(function (_context23) {
                while (1)
                    switch (_context23.n) {
                        case 0:
                            _context23.n = 1;
                            return api.post('/rolepolicy', requestData);
                        case 1:
                            response = _context23.v;
                            return _context23.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee23);
        }));
        function createRolePolicy(_x26) {
            return _createRolePolicy.apply(this, arguments);
        }
        return createRolePolicy;
    }(),
    /**
     * Assign a policy to a role (legacy method - kept for backward compatibility)
     */
    assignPolicyToRole: function () {
        var _assignPolicyToRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee24(roleId, policyId) {
            var response;
            return _regenerator().w(function (_context24) {
                while (1)
                    switch (_context24.n) {
                        case 0:
                            _context24.n = 1;
                            return api.post("/role/".concat(roleId, "/policy/").concat(policyId));
                        case 1:
                            response = _context24.v;
                            return _context24.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee24);
        }));
        function assignPolicyToRole(_x27, _x28) {
            return _assignPolicyToRole.apply(this, arguments);
        }
        return assignPolicyToRole;
    }(),
    /**
     * Remove a policy from a role (legacy method - kept for backward compatibility)
     */
    removePolicyFromRole: function () {
        var _removePolicyFromRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee25(roleId, policyId) {
            var response;
            return _regenerator().w(function (_context25) {
                while (1)
                    switch (_context25.n) {
                        case 0:
                            _context25.n = 1;
                            return api["delete"]("/role/".concat(roleId, "/policy/").concat(policyId));
                        case 1:
                            response = _context25.v;
                            return _context25.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee25);
        }));
        function removePolicyFromRole(_x29, _x30) {
            return _removePolicyFromRole.apply(this, arguments);
        }
        return removePolicyFromRole;
    }(),
    /**
     * Delete all role-policy mappings for a specific role
     */
    deleteAllRolePolicies: function () {
        var _deleteAllRolePolicies = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee26(roleId) {
            var rolePoliciesResponse, rolePolicies, _iterator, _step, policy, _t;
            return _regenerator().w(function (_context26) {
                while (1)
                    switch (_context26.p = _context26.n) {
                        case 0:
                            _context26.n = 1;
                            return UserAPI.getRolePolicies(roleId);
                        case 1:
                            rolePoliciesResponse = _context26.v;
                            rolePolicies = rolePoliciesResponse.resource; // Delete each rolepolicy record using the proper /rolepolicy/:rolepolicy_id endpoint
                            _iterator = _createForOfIteratorHelper(rolePolicies);
                            _context26.p = 2;
                            _iterator.s();
                        case 3:
                            if ((_step = _iterator.n()).done) {
                                _context26.n = 5;
                                break;
                            }
                            policy = _step.value;
                            _context26.n = 4;
                            return UserAPI.deleteRolePolicyById(policy.rolepolicy_id);
                        case 4:
                            _context26.n = 3;
                            break;
                        case 5:
                            _context26.n = 7;
                            break;
                        case 6:
                            _context26.p = 6;
                            _t = _context26.v;
                            _iterator.e(_t);
                        case 7:
                            _context26.p = 7;
                            _iterator.f();
                            return _context26.f(7);
                        case 8:
                            return _context26.a(2);
                    }
            }, _callee26, null, [[2, 6, 7, 8]]);
        }));
        function deleteAllRolePolicies(_x31) {
            return _deleteAllRolePolicies.apply(this, arguments);
        }
        return deleteAllRolePolicies;
    }(),
    /**
     * Remove specific policies from a role using the proper rolepolicy deletion API
     */
    removeSpecificPoliciesFromRole: function () {
        var _removeSpecificPoliciesFromRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee27(roleId, policyIds) {
            var rolePoliciesResponse, rolePolicies, rolePolicyIdsToDelete, _iterator2, _step2, rolePolicyId, _t2;
            return _regenerator().w(function (_context27) {
                while (1)
                    switch (_context27.p = _context27.n) {
                        case 0:
                            _context27.n = 1;
                            return UserAPI.getRolePolicies(roleId);
                        case 1:
                            rolePoliciesResponse = _context27.v;
                            rolePolicies = rolePoliciesResponse.resource; // Find the rolepolicy IDs for the policies we want to remove
                            rolePolicyIdsToDelete = rolePolicies.filter(function (policy) {
                                return policyIds.includes(Number(policy.id));
                            }).map(function (policy) {
                                return policy.rolepolicy_id;
                            }); // Delete each rolepolicy record using the proper /rolepolicy/:rolepolicy_id endpoint
                            _iterator2 = _createForOfIteratorHelper(rolePolicyIdsToDelete);
                            _context27.p = 2;
                            _iterator2.s();
                        case 3:
                            if ((_step2 = _iterator2.n()).done) {
                                _context27.n = 5;
                                break;
                            }
                            rolePolicyId = _step2.value;
                            _context27.n = 4;
                            return UserAPI.deleteRolePolicyById(rolePolicyId);
                        case 4:
                            _context27.n = 3;
                            break;
                        case 5:
                            _context27.n = 7;
                            break;
                        case 6:
                            _context27.p = 6;
                            _t2 = _context27.v;
                            _iterator2.e(_t2);
                        case 7:
                            _context27.p = 7;
                            _iterator2.f();
                            return _context27.f(7);
                        case 8:
                            return _context27.a(2);
                    }
            }, _callee27, null, [[2, 6, 7, 8]]);
        }));
        function removeSpecificPoliciesFromRole(_x32, _x33) {
            return _removeSpecificPoliciesFromRole.apply(this, arguments);
        }
        return removeSpecificPoliciesFromRole;
    }(),
    /**
     * Get all applications
     */
    getAllApplications: function () {
        var _getAllApplications = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee28(orgId) {
            var params, response;
            return _regenerator().w(function (_context28) {
                while (1)
                    switch (_context28.n) {
                        case 0:
                            params = _objectSpread({
                                all: true
                            }, orgId ? {
                                orgId: orgId
                            } : {});
                            _context28.n = 1;
                            return api.get('/application', {
                                params: params
                            });
                        case 1:
                            response = _context28.v;
                            return _context28.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee28);
        }));
        function getAllApplications(_x34) {
            return _getAllApplications.apply(this, arguments);
        }
        return getAllApplications;
    }(),
    /**
     * Get  applications
     */
    getApplications: function () {
        var _getApplications = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee29(orgId) {
            var params, response;
            return _regenerator().w(function (_context29) {
                while (1)
                    switch (_context29.n) {
                        case 0:
                            params = orgId ? {
                                orgId: orgId
                            } : {};
                            _context29.n = 1;
                            return api.get('/application', {
                                params: params
                            });
                        case 1:
                            response = _context29.v;
                            return _context29.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee29);
        }));
        function getApplications(_x35) {
            return _getApplications.apply(this, arguments);
        }
        return getApplications;
    }(),
    /**
     * Get application by ID
     */
    getApplicationById: function () {
        var _getApplicationById = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee30(applicationId) {
            var response;
            return _regenerator().w(function (_context30) {
                while (1)
                    switch (_context30.n) {
                        case 0:
                            _context30.n = 1;
                            return api.get("/application/".concat(applicationId));
                        case 1:
                            response = _context30.v;
                            return _context30.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee30);
        }));
        function getApplicationById(_x36) {
            return _getApplicationById.apply(this, arguments);
        }
        return getApplicationById;
    }(),
    /**
     * Resend registration email for external users
     */
    resendRegistrationEmail: function () {
        var _resendRegistrationEmail = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee31(userId) {
            var response;
            return _regenerator().w(function (_context31) {
                while (1)
                    switch (_context31.n) {
                        case 0:
                            _context31.n = 1;
                            return api.post("/user/".concat(userId, "/invite/resend"), {
                                userId: userId
                            });
                        case 1:
                            response = _context31.v;
                            return _context31.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee31);
        }));
        function resendRegistrationEmail(_x37) {
            return _resendRegistrationEmail.apply(this, arguments);
        }
        return resendRegistrationEmail;
    }(),
    /**
     * Reset password for external users
     */
    resetPassword: function () {
        var _resetPassword = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee32(userId) {
            var response;
            return _regenerator().w(function (_context32) {
                while (1)
                    switch (_context32.n) {
                        case 0:
                            _context32.n = 1;
                            return api.post("/user/".concat(userId, "/passwordreset/initiate"));
                        case 1:
                            response = _context32.v;
                            return _context32.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee32);
        }));
        function resetPassword(_x38) {
            return _resetPassword.apply(this, arguments);
        }
        return resetPassword;
    }(),
    /**
     * Validate email address using UserLookUp API via backend
     */
    validateEmail: function () {
        var _validateEmail = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee33(email) {
            var response, data;
            return _regenerator().w(function (_context33) {
                while (1)
                    switch (_context33.n) {
                        case 0:
                            _context33.n = 1;
                            return api.get('/user/userlookup', {
                                params: {
                                    email: email
                                }
                            });
                        case 1:
                            response = _context33.v;
                            // The backend now returns a structured response with resourceType
                            data = response === null || response === void 0 ? void 0 : response.data;
                            return _context33.a(2, {
                                isValid: data === null || data === void 0 ? void 0 : data.isValid,
                                userInfo: data === null || data === void 0 ? void 0 : data.userInfo,
                                error: data === null || data === void 0 ? void 0 : data.error
                            });
                    }
            }, _callee33);
        }));
        function validateEmail(_x39) {
            return _validateEmail.apply(this, arguments);
        }
        return validateEmail;
    }(),
    /**
     * Create a new application
     */
    createApplication: function () {
        var _createApplication = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee34(applicationData) {
            var response;
            return _regenerator().w(function (_context34) {
                while (1)
                    switch (_context34.n) {
                        case 0:
                            _context34.n = 1;
                            return api.post('/application', applicationData);
                        case 1:
                            response = _context34.v;
                            return _context34.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee34);
        }));
        function createApplication(_x40) {
            return _createApplication.apply(this, arguments);
        }
        return createApplication;
    }(),
    /**
     * Update an application
     */
    updateApplication: function () {
        var _updateApplication = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee35(applicationId, applicationData) {
            var response;
            return _regenerator().w(function (_context35) {
                while (1)
                    switch (_context35.n) {
                        case 0:
                            _context35.n = 1;
                            return api.put("/application/".concat(applicationId), applicationData);
                        case 1:
                            response = _context35.v;
                            return _context35.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee35);
        }));
        function updateApplication(_x41, _x42) {
            return _updateApplication.apply(this, arguments);
        }
        return updateApplication;
    }(),
    /**
     * Delete an application
     */
    deleteApplication: function () {
        var _deleteApplication = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee36(applicationId) {
            var response;
            return _regenerator().w(function (_context36) {
                while (1)
                    switch (_context36.n) {
                        case 0:
                            _context36.n = 1;
                            return api["delete"]("/application/".concat(applicationId));
                        case 1:
                            response = _context36.v;
                            return _context36.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee36);
        }));
        function deleteApplication(_x43) {
            return _deleteApplication.apply(this, arguments);
        }
        return deleteApplication;
    }(),
    /**
     * Get all user groups or user groups for a specific organization
     */
    getUserGroups: function () {
        var _getUserGroups = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee37(organizationId) {
            var params, response;
            return _regenerator().w(function (_context37) {
                while (1)
                    switch (_context37.n) {
                        case 0:
                            params = organizationId ? {
                                organization_id: organizationId,
                                all: true
                            } : {
                                all: true
                            };
                            _context37.n = 1;
                            return api.get('/usergroup', {
                                params: params
                            });
                        case 1:
                            response = _context37.v;
                            return _context37.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee37);
        }));
        function getUserGroups(_x44) {
            return _getUserGroups.apply(this, arguments);
        }
        return getUserGroups;
    }(),
    /**
     * Get a specific user group by ID
     */
    getUserGroupById: function () {
        var _getUserGroupById = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee38(id) {
            var response;
            return _regenerator().w(function (_context38) {
                while (1)
                    switch (_context38.n) {
                        case 0:
                            _context38.n = 1;
                            return api.get("/usergroup/".concat(id));
                        case 1:
                            response = _context38.v;
                            return _context38.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee38);
        }));
        function getUserGroupById(_x45) {
            return _getUserGroupById.apply(this, arguments);
        }
        return getUserGroupById;
    }(),
    /**
     * Create a new user group
     */
    createUserGroup: function () {
        var _createUserGroup = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee39(groupData) {
            var response;
            return _regenerator().w(function (_context39) {
                while (1)
                    switch (_context39.n) {
                        case 0:
                            _context39.n = 1;
                            return api.post('/usergroup', groupData);
                        case 1:
                            response = _context39.v;
                            return _context39.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee39);
        }));
        function createUserGroup(_x46) {
            return _createUserGroup.apply(this, arguments);
        }
        return createUserGroup;
    }(),
    /**
     * Update an existing user group
     */
    updateUserGroup: function () {
        var _updateUserGroup = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee40(id, groupData) {
            var response;
            return _regenerator().w(function (_context40) {
                while (1)
                    switch (_context40.n) {
                        case 0:
                            _context40.n = 1;
                            return api.put("/usergroup/".concat(id), groupData);
                        case 1:
                            response = _context40.v;
                            return _context40.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee40);
        }));
        function updateUserGroup(_x47, _x48) {
            return _updateUserGroup.apply(this, arguments);
        }
        return updateUserGroup;
    }(),
    /**
     * Delete a user group
     */
    deleteUserGroup: function () {
        var _deleteUserGroup = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee41(id) {
            var response;
            return _regenerator().w(function (_context41) {
                while (1)
                    switch (_context41.n) {
                        case 0:
                            _context41.n = 1;
                            return api["delete"]("/usergroup/".concat(id));
                        case 1:
                            response = _context41.v;
                            return _context41.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee41);
        }));
        function deleteUserGroup(_x49) {
            return _deleteUserGroup.apply(this, arguments);
        }
        return deleteUserGroup;
    }(),
    /**
     * Get members of a user group
     */
    getUserGroupMembers: function () {
        var _getUserGroupMembers = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee42(groupId) {
            var response;
            return _regenerator().w(function (_context42) {
                while (1)
                    switch (_context42.n) {
                        case 0:
                            _context42.n = 1;
                            return api.get("/usergroup/".concat(groupId, "/members"));
                        case 1:
                            response = _context42.v;
                            return _context42.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee42);
        }));
        function getUserGroupMembers(_x50) {
            return _getUserGroupMembers.apply(this, arguments);
        }
        return getUserGroupMembers;
    }(),
    /**
     * Add users to a user group (bulk assignment)
     */
    addUsersToGroup: function () {
        var _addUsersToGroup = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee43(groupId, userIds) {
            var response;
            return _regenerator().w(function (_context43) {
                while (1)
                    switch (_context43.n) {
                        case 0:
                            _context43.n = 1;
                            return api.post("/usergroup/".concat(groupId, "/assignment/bulk"), {
                                add: userIds,
                                remove: []
                            });
                        case 1:
                            response = _context43.v;
                            return _context43.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee43);
        }));
        function addUsersToGroup(_x51, _x52) {
            return _addUsersToGroup.apply(this, arguments);
        }
        return addUsersToGroup;
    }(),
    /**
     * Remove multiple users from a user group (bulk removal)
     */
    removeUsersFromGroup: function () {
        var _removeUsersFromGroup = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee44(groupId, userIds) {
            var response;
            return _regenerator().w(function (_context44) {
                while (1)
                    switch (_context44.n) {
                        case 0:
                            _context44.n = 1;
                            return api.post("/usergroup/".concat(groupId, "/assignment/bulk"), {
                                add: [],
                                remove: userIds
                            });
                        case 1:
                            response = _context44.v;
                            return _context44.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee44);
        }));
        function removeUsersFromGroup(_x53, _x54) {
            return _removeUsersFromGroup.apply(this, arguments);
        }
        return removeUsersFromGroup;
    }(),
    /**
     * Assign roles to a principal (user or user group)
     * principal_type: 1 = User, 2 = Group
     */
    assignRolesToPrincipal: function () {
        var _assignRolesToPrincipal = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee45(roleIds, principalId, principalType) {
            var results, _iterator3, _step3, roleId, response, _t3;
            return _regenerator().w(function (_context45) {
                while (1)
                    switch (_context45.p = _context45.n) {
                        case 0:
                            results = [];
                            _iterator3 = _createForOfIteratorHelper(roleIds);
                            _context45.p = 1;
                            _iterator3.s();
                        case 2:
                            if ((_step3 = _iterator3.n()).done) {
                                _context45.n = 5;
                                break;
                            }
                            roleId = _step3.value;
                            _context45.n = 3;
                            return api.post("/role/".concat(roleId, "/assignment"), {
                                assign: [{
                                        principal_id: principalId,
                                        principal_type: principalType
                                    }]
                            });
                        case 3:
                            response = _context45.v;
                            results.push(response === null || response === void 0 ? void 0 : response.data);
                        case 4:
                            _context45.n = 2;
                            break;
                        case 5:
                            _context45.n = 7;
                            break;
                        case 6:
                            _context45.p = 6;
                            _t3 = _context45.v;
                            _iterator3.e(_t3);
                        case 7:
                            _context45.p = 7;
                            _iterator3.f();
                            return _context45.f(7);
                        case 8:
                            return _context45.a(2, results);
                    }
            }, _callee45, null, [[1, 6, 7, 8]]);
        }));
        function assignRolesToPrincipal(_x55, _x56, _x57) {
            return _assignRolesToPrincipal.apply(this, arguments);
        }
        return assignRolesToPrincipal;
    }(),
    /**
     * Remove roles from a principal (user or user group)
     * principal_type: 1 = User, 2 = Group
     */
    removeRolesFromPrincipal: function () {
        var _removeRolesFromPrincipal = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee46(roleIds, principalId, principalType) {
            var results, _iterator4, _step4, roleId, response, _t4;
            return _regenerator().w(function (_context46) {
                while (1)
                    switch (_context46.p = _context46.n) {
                        case 0:
                            results = [];
                            _iterator4 = _createForOfIteratorHelper(roleIds);
                            _context46.p = 1;
                            _iterator4.s();
                        case 2:
                            if ((_step4 = _iterator4.n()).done) {
                                _context46.n = 5;
                                break;
                            }
                            roleId = _step4.value;
                            _context46.n = 3;
                            return api.post("/role/".concat(roleId, "/assignment"), {
                                remove: [{
                                        principal_id: principalId,
                                        principal_type: principalType
                                    }]
                            });
                        case 3:
                            response = _context46.v;
                            results.push(response === null || response === void 0 ? void 0 : response.data);
                        case 4:
                            _context46.n = 2;
                            break;
                        case 5:
                            _context46.n = 7;
                            break;
                        case 6:
                            _context46.p = 6;
                            _t4 = _context46.v;
                            _iterator4.e(_t4);
                        case 7:
                            _context46.p = 7;
                            _iterator4.f();
                            return _context46.f(7);
                        case 8:
                            return _context46.a(2, results);
                    }
            }, _callee46, null, [[1, 6, 7, 8]]);
        }));
        function removeRolesFromPrincipal(_x58, _x59, _x60) {
            return _removeRolesFromPrincipal.apply(this, arguments);
        }
        return removeRolesFromPrincipal;
    }()
};
